import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import Facebook from './Facebook';
import WeFight from './WeFight';
import Thanks from './Thanks';

const RouterComponent = (props) => {
    return (
        <div>
            <Router>
                <Switch>
                    <Route exact path = "/petycja" component = {WeFight} />
                    <Route exact path = "/login" component = {Facebook} />
                    <Route exact path = "/thanks" component = {Thanks} />
                </Switch>
            </Router>
        </div>
    )
}

export default RouterComponent;